import React from 'react';
import {
  EVIDENCE_OVERRIDE_LESS,
  EVIDENCE_OVERRIDE_MORE,
  EVIDENCE_OVERRIDE_REMOVED,
} from '../../utils/evidenceOverrides';

const CONTROLS = [
  { state: EVIDENCE_OVERRIDE_REMOVED, label: 'Remove', active: 'Removed', title: 'Remove this evidence' },
  { state: EVIDENCE_OVERRIDE_LESS, label: 'Less relevant', active: 'Less relevant', title: 'Mark this evidence as less relevant' },
  { state: EVIDENCE_OVERRIDE_MORE, label: 'More relevant', active: 'More relevant', title: 'Mark this evidence as more relevant' },
];

/**
 * The three controls on one piece of evidence (TDI-406): remove, less
 * relevant, more relevant. One state at a time; pressing the active one
 * clears it. The choice is saved with the paragraph as soon as it is made
 * and is what "Regenerate from the adjusted evidence" redrafts from.
 */
export function EvidencePieceControls({ state, disabled, onChange }) {
  return (
    <div className="mt-1.5 flex flex-wrap gap-1" role="group" aria-label="Adjust this evidence">
      {CONTROLS.map((control) => {
        const isActive = state === control.state;
        return (
          <button
            key={control.state}
            type="button"
            title={control.title}
            aria-pressed={isActive}
            disabled={disabled}
            onClick={() => onChange(isActive ? null : control.state)}
            className={`rounded-full border px-2 py-0.5 text-[11px] leading-5 disabled:opacity-60 disabled:cursor-not-allowed ${
              isActive
                ? 'border-primary bg-primary text-white'
                : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            {isActive ? control.active : control.label}
          </button>
        );
      })}
    </div>
  );
}

export default EvidencePieceControls;
